import { render } from "./FormsDetails.vue?vue&type=template&id=20c8bddd&lang=true"
import script from "./FormsDetails.vue?vue&type=script&lang=js"
export * from "./FormsDetails.vue?vue&type=script&lang=js"

import "./FormsDetails.vue?vue&type=style&index=0&id=20c8bddd&scope=true&lang=css"
script.render = render

export default script